/*
 *
 * PardotVerify reducer
 *
 */
import produce from 'immer';
import { VERIFY_PARDOT } from './constants';

export const initialState = {
  isVerify: true,
  error: false,
};

/* eslint-disable default-case, no-param-reassign */
const pardotVerifyReducer = (state = initialState, action) => {
  return produce(state, draft => {
    switch (action.type) {
      case VERIFY_PARDOT.START:
        draft.isVerify = true;
        draft.error = false;
        break;

      case VERIFY_PARDOT.SUCCESS:
        draft.isVerify = false;
        draft.error = false;
        break;

      case VERIFY_PARDOT.ERROR:
        draft.isVerify = false;
        draft.error = action.payload.error;
        break;
    }
  });
};

export default pardotVerifyReducer;
